<template>
  <section class="view-stack announcements-view">
    <article class="dashboard-panel">
      <div class="panel-heading">
        <div><h2>公告</h2><p>查看系统发布的全部公告和阅读状态。</p></div>
        <el-button icon="el-icon-refresh" circle plain :loading="loading" @click="loadAnnouncements" />
      </div>
      <div v-loading="loading" class="announcement-list">
        <button v-for="item in items" :key="item.id" class="announcement-item" type="button" @click="openAnnouncement(item)">
          <span class="announcement-item-main"><strong>{{ item.title }}</strong><small>{{ formatDate(item.updateTime || item.createTime) }}</small></span>
          <el-tag :type="item.isRead ? 'info' : 'warning'" size="mini">{{ item.isRead ? '已读' : '未读' }}</el-tag>
        </button>
        <el-empty v-if="!loading && !items.length" description="暂无公告" />
      </div>
    </article>
    <AnnouncementDialog
      v-if="selected"
      :announcement="selected"
      :visible.sync="detailVisible"
    />
  </section>
</template>

<script>
import { fetchAnnouncements, markAnnouncementRead } from '../../api/announcements';
import AnnouncementDialog from '../../components/AnnouncementDialog.vue';

export default {
  name: 'AnnouncementsView',
  components: { AnnouncementDialog },
  data() { return { items: [], loading: false, selected: null, detailVisible: false }; },
  created() { this.loadAnnouncements(); },
  methods: {
    formatDate(value) { if (!value) return '--'; const date = new Date(value); return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString(); },
    async loadAnnouncements() {
      this.loading = true;
      try { const { data } = await fetchAnnouncements(); if (!data || data.code !== 0) throw new Error((data && data.message) || '公告加载失败'); this.items = Array.isArray(data.data) ? data.data : []; }
      catch (error) { this.$message.error(error.message || '公告加载失败'); }
      finally { this.loading = false; }
    },
    async openAnnouncement(item) {
      this.selected = item; this.detailVisible = true;
      if (item.isRead) return;
      try { const { data } = await markAnnouncementRead(item.id); if (data && data.code === 0) this.$set(item, 'isRead', true); } catch (error) { /* detail remains available */ }
    }
  }
};
</script>

<style scoped>
.announcement-list { min-height: 160px; }.announcement-item { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 16px 4px; border: 0; border-bottom: 1px solid #edf2f3; background: transparent; color: inherit; text-align: left; cursor: pointer; }.announcement-item:hover { background: #f8fbfb; }.announcement-item-main { display: flex; flex-direction: column; gap: 6px; min-width: 0; }.announcement-item-main strong { overflow: hidden; color: #27454d; font-size: 15px; text-overflow: ellipsis; white-space: nowrap; }.announcement-item-main small { color: #91a2a7; font-size: 12px; }
</style>
